<template>
    <div>
        <b-button-group size="sm" class="w-100 table-actions">
            <b-button
                variant="table"
                v-if="checkActionAllow('show')"
                @click="showItem(row.index)"
            >
                <i class="far fa-eye"></i>
            </b-button>
        </b-button-group>
    </div>
</template>
<script>
import { checkActionAllow } from '@/mixins'

export default {
    props: {
        row: {type: Object, required: true},                                                // Row of table
        actionAllows: {type: Array, required: false, default: function () { return [] }},   // Array of rules for action allows
    },
    mixins: [
        checkActionAllow
    ],
    data() {
        return {
        }
    },
    methods: {
        showItem(index) {
            this.$emit('universalEmit', 'show', index)
        },
    }
}
</script>

